import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { ActualSizeTabName, SIZE_TAB } from '../../services/actual-size/types';

interface SizeInfoTabsProps {
  activeTab: ActualSizeTabName;
  onTabClick: (tab: ActualSizeTabName) => void;
}

const TABS: Array<{ id: ActualSizeTabName; label: string }> = [
  { id: SIZE_TAB.MY_PURCHASE, label: '나의 구매내역' },
  { id: SIZE_TAB.DIRECT_INPUT, label: '직접 입력한 사이즈' },
];

export const SizeInfoTabs = ({ activeTab, onTabClick }: SizeInfoTabsProps) => {
  return (
    <Tabs>
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <Tab key={tab.id} active={isActive} onClick={() => onTabClick(tab.id)}>
            <Text variant='Body_14_SemiBold' color={isActive ? 'textStrong' : 'textTertiary'}>
              {tab.label}
            </Text>
          </Tab>
        );
      })}
    </Tabs>
  );
};

const Tabs = styled.div`
  display: flex;
  background-color: ${vars.color.fillTertiary};
  border-radius: 6px;
  padding: 2px;
`;

const Tab = styled.div<{ active: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  cursor: pointer;
  background-color: ${({ active }) => (active ? vars.color.backgroundElevated : 'transparent')};
  transition: background-color 0.2s;
  border-radius: 4px;
`;
